module.exports = __webpack_public_path__ + "img/img_withdraw_passcard_banner.8b308ced.png";